import request from "@/utils/request";

export const url = {
  GetAutoMessageList: "/api/AutoMessage/GetAutoMessagePageList",
  SetReadAll: "/api/AutoMessage/SetReadAll",
  SetIsRead: "/api/AutoMessage/SetIsRead",
  GetChanelMessagePage: "/api/ChannelRmind/GetMessagePage", //获取待确认的渠道订单
  ConfirmChannelOrder: "/api/Order/ConfirmChannelOrder", //确认渠道订单
};
function sendRequest(apiUrl, params, type) {
  return request({
    url: apiUrl,
    method: type,
    data: params,
  });
}

export default class messageApi {
  /**
   * 获取房态信息
   * @description: 获取房态
   * @param {Object} data
   * @return:
   */
  static GetAutoMessageList(params, type = "post") {
    return sendRequest(url.GetAutoMessageList, params, type);
  }
  /**
   * 设置全部已读
   * @description:
   * @param {type}
   * @return:
   */
  static SetReadAll(params, type = "post") {
    return sendRequest(url.SetReadAll, params, type);
  }
  /**
   * 设置已读
   * @description:
   * @param {type}
   * @return:
   */
  static SetIsRead(params, type = "post") {
    return sendRequest(url.SetIsRead, params, type);
  }
  /**
   * 获取待确认的渠道订单
   * @description: 获取待确认的渠道订单
   * @param {Object} data
   * @return:
   */
  static GetChanelMessagePage(params, type = "post") {
    return sendRequest(url.GetChanelMessagePage, params, type);
  }
  /**
   * 确认渠道订单
   * @description: 确认渠道订单
   * @param {Object} data
   * @return:
   */
  static ConfirmChannelOrder(params, type = "post") {
    return sendRequest(url.ConfirmChannelOrder, params, type);
  }
}
